var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=caret-down-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.24743 11.1399L2.4512 5.6585C1.88544 5.01192 2.34461 4 3.20377 4H12.7962C13.6554 4 14.1146 5.01192 13.5488 5.6585L8.75258 11.1399C8.35417 11.5952 7.64584 11.5952 7.24743 11.1399Z",
    fill: "#343A40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownFill);
export default __webpack_public_path__ + "static/media/caret-down-fill.3a99236cbabf45043aca85cd3752abf0.svg";
export { ForwardRef as ReactComponent };